import React, {useState, useEffect} from 'react'
import classes from './location.module.css'
import Axios from '../../../../../../Axios'
import { Urls } from '../../../../../../Urls'
import Loader from '../../../../../Loader'
import { toast } from 'react-toastify'
import { next_page, save_details_api } from '../../../../Utility'
import { Suggestion } from '../../../../../CompanyProfileNew/FreightMaster/FreightMaster/UploadExcel/Utility'
import { Activity, currentRequestTimeStamp, isMobile } from '../../../../../../Constants'
import mixpanel from 'mixpanel-browser'

const LocationCleaning = ({
    step=2,
    setStep='',
    PreviosStep=0,
    setPreviosStep='',
    excel_details={},
    setExcel_details = '',
    fetch_saved_details='',
    fetch_cleaning_details = '',
    location_list=[],
    setLocation_list=''
}) => {

    const [show, setshow] = useState(false)
    const [location_details, setLocation_details] = useState([])


    useEffect(() => {
        // console.log('inside useffect')
        if(excel_details && excel_details.blob_url && PreviosStep === 0){
            // console.log('inside if')
            fetch_cleaning_details(excel_details.blob_url, excel_details.excel_id)
        } else {
            // console.log('inside else')
            fetch_saved_details(excel_details.excel_id)
        }
    }, [excel_details])

    useEffect(() => {
        (async () => { 
            setshow(true)
            var temp = []
            if(location_list && location_list.length > 0){
                // console.log(location_list.length)
                for(var i = 0 ;i < location_list.length; i++){
                    var temp_location = location_list[i]
                    if(temp_location.type === 'unique'){
                        if(!temp_location.main_location.location){
                            //${temp_location['Districtname']? temp_location['Districtname']:''},${temp_location['Raw State']}
                            // await Axios.get(`${Urls.Autocomplete.Get.getlist}?suggest=${temp_location['Raw Location']}&limit=10&searchFields=locations`)
                            await Axios.get(`${Urls.Autocomplete.Get.getlist}?suggest=${temp_location['Raw Location']}&limit=10&searchFields=new_locations`)
                            .then(res => {
                                if(res.data.value.length > 0){
                                    for(var j = 0; j < res.data.value.length; j++){
                                        if(res.data.value[j].location.location === temp_location['Raw Location'] && res.data.value[j].location.state === temp_location['Raw State']){
                                            temp_location.main_location = res.data.value[j] ? res.data.value[j]: {}
                                            if(temp.filter(location => location['Raw Location'] === temp_location['Raw Location'] && location['Raw State'] === temp_location['Raw State']).length === 0){
                                                temp_location.main_location = res.data.value && res.data.value[j] ? res.data.value[j]: {}
                                                temp.push(temp_location)    
                                            } else{
                                                temp.map(location => {
                                                    if(location['Raw Location'] === temp_location['Raw Location'] && location['Raw State'] === temp_location['Raw State']){
                                                        location.main_location = res.data.value[j] ? res.data.value[j]: {}
                                                    }
                                                    return location
                                                })
                                            }
                                            break
                                        } else {
                                            if(temp.filter(location => location['Raw Location'] === temp_location['Raw Location'] && location['Raw State'] === temp_location['Raw State']).length === 0){
                                                temp_location.main_location = res.data.value && res.data.value[0] ? res.data.value[0]: {}
                                                temp.push(temp_location)    
                                            }
                                        }
                                    }
                                } else{
                                    temp.push(temp_location)
                                }
                            })
                            // .catch(err=> console.log(err))
                            .catch((err) => {
                                setshow(false);
                                console.log(err);
                              });
                        } else{ 
                            temp.push(temp_location)
                        }
                    } 
                    else {
                        if(!temp_location.main_location.location){
                            //,${temp_location['Raw State']}
                            await Axios.get(`${Urls.Autocomplete.Get.getlist}?suggest=${temp_location['Raw Location']}&limit=10&searchFields=new_locations`)
                            .then(res => {
                                if(res.data.value.length > 0){
                                    for(var j = 0; j < res.data.value.length; j++){
                                        if(res.data.value[j].location.location === temp_location['Raw Location'] && res.data.value[j].location.state === temp_location['Raw State']){
                                            temp_location.main_location = res.data.value[j] ? res.data.value[j]: {}
                                            if(temp.filter(location => location['Raw Location'] === temp_location['Raw Location'] && location['Raw State'] === temp_location['Raw State']).length === 0){
                                                temp_location.main_location = res.data.value && res.data.value[j] ? res.data.value[j]: {}
                                                temp.push(temp_location)    
                                            } else{
                                                temp.map(location => {
                                                    if(location['Raw Location'] === temp_location['Raw Location'] && location['Raw State'] === temp_location['Raw State']){
                                                        location.main_location = res.data.value[j] ? res.data.value[j]: {}
                                                    }
                                                    return location
                                                })
                                            }
                                            break
                                        } else {
                                            if(temp.filter(location => location['Raw Location'] === temp_location['Raw Location'] && location['Raw State'] === temp_location['Raw State']).length === 0){
                                                temp_location.main_location = res.data.value && res.data.value[0] ? res.data.value[0]: {}
                                                temp.push(temp_location)    
                                            }
                                        }
                                    }
                                } else{
                                    temp.push(temp_location)
                                }
                            })
                            // .catch(err=> console.log(err))
                            .catch((err) => {
                                setshow(false);
                                console.log(err);
                              });
                        } else{ 
                            temp.push(temp_location)
                        }
                    } 
                    if(i === location_list.length - 1){
                        // console.log(temp.length)
                        setLocation_details(temp)
                        setshow(false)
                    }
                }
            }
        })()
    }, [location_list])

    const setSelectedOrigin = (value, e) => {
        var temp_details = location_details.map((location) => {
            if(value.index === location.index ){
                location['main_location'] = e
            }
            return location
        })
        setLocation_details(temp_details)
    }

    const check_location_details = () => {
        for(var i = 0; i< location_details.length; i++){
            if(!location_details[i].main_location || !location_details[i].main_location.location){
                return false
            }
        }
        return true
    }

    const save_details = (locations) => {
        setshow(true)
        var unique_df = [], not_found_new = [], multistate = [], nospellsugg = []
        locations.map((loc) => {
            loc["user_input"] = "accepted"
            if(loc.type === 'unique') {
                unique_df.push(loc)
            }
            if(loc.type === 'not_found') {
                not_found_new.push(loc)
            }
            if(loc.type === 'multistate'){
                multistate.push(loc)
            }
            if(loc.type === 'no_spellsugg'){
                nospellsugg.push(loc)
            }
        })
        if(unique_df && unique_df.length > 0) {
            var payload = {
                data: unique_df,
                key:'unique_df',
                excel_id:excel_details.excel_id
            }
            save_details_api(payload)
            .then(res => {
                setshow(false)
                // toast.success('Unique Saved')
            })
            // .catch(e => console.log(e))
            .catch((err) => {
                setshow(false);
                console.log(err);
              });
        }
        if(not_found_new && not_found_new.length > 0){
            var payload = {
                data: not_found_new,
                key:'not_found_new',
                excel_id:excel_details.excel_id
            }
            save_details_api(payload)
            .then(res => {
                setshow(false)
                // toast.success('Not Found Saved')
            })
            // .catch(e => console.log(e))
            .catch((err) => {
                setshow(false);
                console.log(err);
              });
        }
        if(multistate && multistate.length > 0){
            var payload = {
                data: multistate,
                key:'multistate',
                excel_id:excel_details.excel_id
            }
            save_details_api(payload)
            .then(res => {
                // toast.success('MultiState Saved')
            })
        }
        if(nospellsugg && nospellsugg.length > 0){
            var payload = {
                data: nospellsugg,
                key:'no_spellsugg',
                excel_id:excel_details.excel_id
            }
            save_details_api(payload)
            .then(res => {
                // toast.success('MultiState Saved')
            })
        }
        next_page({"data":"truckandtransporter","excel_id":excel_details.excel_id,"key":"page"})
        .then(res => {
            setStep(3)
        })
        // .catch(e => console.log(e))
        .catch((err) => {
            setshow(false);
            console.log(err);
          });
    }

    const go_to_clean_truck = () => {
        Activity([{ "screen": "Location Cleaning", "module": "My Freight Benchmark", "user_activity": `Location Screen: User clicked on Next Button`, "timestamp": currentRequestTimeStamp() }])
        mixpanel.track(`Benchmark Location Screen: User has clicked on Next Button`, {
            ApplicationName: `${Urls.mixpanelappname}`,
            ScreenName: 'LoRRI-Benchmark',
            ModuleName: 'edit_page',
            ActivityLog: `UserClickedOnNextButton`,
            Data: `None`,
            Definition: `Benchmark Location Screen: User has clicked on Next Button`,
            ActivityType: 'event_view',
            UserName: `${localStorage.getItem("userdetails")}`,
            UserEmail: `${localStorage.getItem("useremail")}`,
            CompanyName: `${localStorage.getItem("companyname")}`
        });
        if(!check_location_details()){
            toast.info('Please Select location from dropdowns')
        } else { 
            setExcel_details({
                ...excel_details, page:'truckandtransporter'
            })
            setLocation_list(location_details)
            save_details(location_details)
            setPreviosStep(2)
        }
    }

    const cancelProcess =()=>{
        if (window.confirm("Are you sure to cancel?")) {
        next_page({"data":"completed","excel_id":excel_details.excel_id,"key":"page"}) //Imp
        document.getElementById("close_contactus1").click()
        toast.success('Process Cancelled Successfully')
        }
    }

    return (
        <div>
            <div className={classes['location_headers']}>
                <div className={classes['location_name']}>Location Name</div>
                <div className={classes['location_district']}>Location District</div>
                <div className={classes['location_state']}>Location State</div>
                <div className={classes['location_autosuggest']}>Check Location</div>
            </div>  
            <div className={classes['location_details']}>
                <Loader show={show}/>
                {location_details.length > 0 ? location_details.map((loc) => {
                    return <div className={classes['location']}>
                        <div className={`${classes['location_name']}`}><b>{isMobile()? "Location Name:": ""}</b> {loc['Raw Location']}</div>
                        <div className={`${classes['location_state']}`}><b>{isMobile()? "Location District:": ""}</b> {loc['Districtname']}</div>
                        <div className={`${classes['location_district']}`}><b>{isMobile()? "Location State:": ""}</b> {loc['Raw State']}</div>
                        <div className={`${loc['main_location'] && loc['main_location'].location ? classes['location_autosuggest']: classes['error']}`}>
                            <div><b>{isMobile()? "Check Location:": ""}</b></div>
                            <Suggestion 
                                value={loc.main_location? loc.main_location: ''}
                                onSelect={e => setSelectedOrigin(loc, e)}
                            />
                        </div>
                    </div>
                }): <center>No Location Found</center>}
            </div>
            <center style={{marginTop: '3%'}}>
                <button className='btn btn-sm btn-danger mr-3' onClick={e => cancelProcess()}>Cancel</button>
                <button className="btn btn-sm btn-primary" disabled={show} onClick={e => go_to_clean_truck()}>Next</button>
            </center>
        </div>
    )
}

export default LocationCleaning
